var XPortal = XPortal || {};
XPortal.inputHandler =
{
    ControlSelector: ".input-group",
    Init: function (container) {
        var self = this;
        self.clearInput(container)
    },
    clearInput: function (container) {
        var $inputsGroups = container.find(this.ControlSelector);
        var knownInputs = [];

        $inputsGroups.each(function () {
            var $group = $(this);
            var $input = $group.find('.form-control');
            var $buttonClear = $group.find('.btn-clear');
            var $buttonShow = $group.find('.btn-show-pass');
            var sttgs = XPortal.Main.GetSettingsFor($input);

            var checkValue = function () {
                if ($input.val()) {
                    $group.addClass('input-group-focus');
                } else {
                    $group.removeClass('input-group-focus');
                }
            };

            checkValue();

            knownInputs.push(
                {
                    $input,
                    checkValue,
                    fname: sttgs.fieldname ? sttgs.fieldname.toLowerCase() : ""
                }
            );

            $input.on('focus blur change input dispatchFieldEvent', checkValue);

            if ($buttonClear.length) {
                $buttonClear.on('click', function () {
                    $input.val('');
                    $input.trigger('change');
                    $group.removeClass('input-group-focus');
                });
            }

            if ($buttonShow.length) {
                $buttonShow.on('click', function (event) {
                    event.preventDefault();
                    $input[0].setSelectionRange($input.val().length, $input.val().length);
                    $input.attr('type', $input.attr('type') === 'password' ? 'text' : 'password');
                    
                    var showPass = $(this).find(".showPasswordIcon");
                    var hidePass = $(this).find(".hidePasswordIcon");
                        showPass.toggleClass("d-none");
                        hidePass.toggleClass("d-none");
                    $input.focus();
                });
            }
        });
        if (!XPortal.Store.AppStore) XPortal.Store.Init();
        XPortal.Store.AppStore.subscribe(() => {
            var state = XPortal.Store.AppStore.getState();
            var lasteAction = state.lastAction;
            if(lasteAction && lasteAction.field && lasteAction.field.field){
                knownInputs.forEach(x=>{
                    if(x.fname==lasteAction.field.field)
                        x.checkValue();                    
                })
            } 
        });
    }
};